import { render } from "./ItemModal.vue?vue&type=template&id=c955513c&scoped=true"
import script from "./ItemModal.vue?vue&type=script&lang=js"
export * from "./ItemModal.vue?vue&type=script&lang=js"

import "./ItemModal.vue?vue&type=style&index=0&id=c955513c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c955513c"

export default script